import { styled } from '@mui/material/styles';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import dayjs from 'dayjs';
import { maxSelectableDays, totalSelectionDays } from './DroneLogistics';
import {
	primary,
	brightGreen,
	lightGreen,
	neutral2,
	neutral4,
	black,
} from '../../../../../styles/colors';

const selectedIconStyle = {
	backgroundColor: neutral2,
	color: brightGreen,
	border: `1px solid ${brightGreen}`,
};

const HighlightedDay = styled(PickersDay)(({ _ }) => ({
	'&.Mui-selected': selectedIconStyle,
	'&.Mui-selected: hover': {
		...selectedIconStyle,
		fontWeight: 'bold',
	},
	'&.Mui-selected:focus': selectedIconStyle,
	'&.Mui-disabled:not(.Mui-selected)': {
		color: neutral4,
	},
}));

//Higlights the dates in highlightedDays array
const HighlightDays = (props) => {
	const {
		selectedDates = [],
		jouleaPreferredDates = [],
		day,
		outsideCurrentMonth,
		...other
	} = props;

	const isSelected =
		!props.outsideCurrentMonth &&
		selectedDates.includes(day.format('YYYY-MM-DD'));

	const isPreferred = jouleaPreferredDates.includes(day.format('YYYY-MM-DD'));
	const dateStyle = isSelected
		? {
				backgroundColor: `${primary} !important`,
				color: neutral2,
		  }
		: isPreferred
		? { backgroundColor: lightGreen, color: black }
		: {
				backgroundColor: neutral2,
				color: black,
		  };

	return (
		<HighlightedDay
			{...other}
			outsideCurrentMonth={outsideCurrentMonth}
			day={day}
			sx={dateStyle}
		/>
	);
};

export function CalendarDateSelector({
	today,
	selectedDates,
	handleDateChange,
}) {
	const maxDate = today.add(maxSelectableDays, 'day');

	// Disable the first 5 days from today
	const first5DaysDisabled = (date) => {
		return dayjs(date).isBefore(today.add(5, 'day'), 'day');
	};

	// Disable the last 21 days so that the selection stays within the 3-month limit
	// Is custom disabled instead of reducing it from maxDate since the months after maxDate are not visible
	// and the user will not be able to see until the end of the selection window
	const disabledDays = (date) => {
		const dayOfWeek = dayjs(date).get('day');
		const diffWithMaxDate = maxDate.diff(date, 'day');
		return (
			dayOfWeek === 0 ||
			dayOfWeek === 6 ||
			diffWithMaxDate < totalSelectionDays ||
			first5DaysDisabled(date)
		);
	};

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<StaticDatePicker
				displayStaticWrapperAs="desktop"
				defaultValue={today}
				shouldDisableDate={disabledDays}
				minDate={today}
				maxDate={maxDate}
				slots={{
					day: HighlightDays,
				}}
				slotProps={{
					day: { selectedDates },
				}}
				onChange={handleDateChange}
			/>
		</LocalizationProvider>
	);
}
